export const EventMasterActionConst = {
  FETCH_ALL_EVENTS_REQUEST: "FETCH_ALL_EVENTS_REQUEST",
  FETCH_ALL_EVENTS_SUCC: "FETCH_ALL_EVENTS_SUCC",
  FETCH_ALL_EVENTS_FAIL: "FETCH_ALL_EVENTS_FAIL",

  FETCH_EVENT_DETAIL_REQUEST: "FETCH_EVENT_DETAIL_REQUEST",
  FETCH_EVENT_DETAIL_SUCC: "FETCH_EVENT_DETAIL_SUCC",
  FETCH_EVENT_DETAIL_FAIL: "FETCH_EVENT_DETAIL_FAIL",

  FETCH_EVENT_COLLABORATION_REQUEST: "FETCH_EVENT_COLLABORATION_REQUEST",
  FETCH_EVENT_COLLABORATION_SUCC: "FETCH_EVENT_COLLABORATION_SUCC",
  FETCH_EVENT_COLLABORATION_FAIL: "FETCH_EVENT_COLLABORATION_FAIL",

  UPDATE_EVENT_REQUEST: "UPDATE_EVENT_REQUEST",
  UPDATE_EVENT_SUCC: "UPDATE_EVENT_SUCC",
  UPDATE_EVENT_FAIL: "UPDATE_EVENT_FAIL",

  PUBLISH_EVENT_REQUEST: "PUBLISH_EVENT_REQUEST",
  PUBLISH_EVENT_SUCC: "PUBLISH_EVENT_SUCC",
  PUBLISH_EVENT_FAIL: "PUBLISH_EVENT_FAIL",

  REMOVE_EVENT_REQUEST: "REMOVE_EVENT_REQUEST",
  REMOVE_EVENT_SUCC: "REMOVE_EVENT_SUCC",
  REMOVE_EVENT_FAIL: "REMOVE_EVENT_FAIL",

  FETCH_FLAGGED_EVENTS_REQUEST: "FETCH_FLAGGED_EVENTS_REQUEST",
  FETCH_FLAGGED_EVENTS_SUCC: "FETCH_FLAGGED_EVENTS_SUCC",
  FETCH_FLAGGED_EVENTS_FAIL: "FETCH_FLAGGED_EVENTS_FAIL",

  FLAG_DECISION_REQUEST: "FLAG_DECISION_REQUEST",
  FLAG_DECISION_SUCC: "FLAG_DECISION_SUCC",
  FLAG_DECISION_FAIL: "FLAG_DECISION_FAIL",

  CLEAR_EVENT_ACTION_STATE: "CLEAR_EVENT_ACTION_STATE",
};
